import { StyleSheet, Platform } from 'react-native'
import type { Theme } from '../src/theme/getTheme'

// Dynamic page-level styles for create page (gamified flow)
export const getCreatePageStyles = (theme: Theme) => StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: theme.background.primary,
  },
  safeArea: {
    flex: 1,
  },
  content: {
    flex: 1,
    paddingHorizontal: Platform.OS === 'web' ? 20 : 14,
    paddingTop: Platform.OS === 'web' ? 0 : 8,
  },
  contentContainerGames: {
    paddingTop: Platform.OS === 'android' ? 12 : 4,
  },
  /**
   * Review ("Your slate"): full-bleed like the Build screen — the step's sections carry their own
   * 16px insets, so keeping the page padding double-padded it and made it visibly narrower than
   * Build. On web, clear the fixed PageHeader so the title is not behind it.
   */
  contentContainerBetting: {
    paddingHorizontal: 0,
    ...(Platform.OS === 'web' && { paddingTop: 60 }),
  },
  contentContainerUserGroups: {
    ...(Platform.OS === 'web' && { paddingTop: 60 }),
  },
  /**
   * Build screen: full-bleed horizontally so the sticky footer bar spans edge-to-edge
   * (inner sections carry their own 16px insets). On web, clear the fixed PageHeader so the
   * VS strip isn't hidden behind it.
   */
  contentContainerBuild: {
    paddingHorizontal: 0,
    ...(Platform.OS === 'web' && { paddingTop: 60 }),
  },
})

